var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('radio-buttons',{attrs:{"options":_vm.options,"value":_vm.on,"active-color":_vm.onColor,"inactive-color":_vm.offColor,"disabled":_vm.disabled},on:{"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }